import 'css-chunksrc/client/scenes/listDuplication/listsList/list/task/styles.scss';export default {
  "task": "_task_1l7di_1",
  "contextualMenu": "_contextualMenu_1l7di_8",
  "taskDetails": "_taskDetails_1l7di_12",
  "name": "_name_1l7di_22",
  "icon": "_icon_1l7di_39",
  "taskAdvancement": "_taskAdvancement_1l7di_43",
  "allocations": "_allocations_1l7di_49",
  "text": "_text_1l7di_56",
  "completionDate": "_completionDate_1l7di_62",
  "tick": "_tick_1l7di_68",
  "late": "_late_1l7di_75",
  "displayedContextualMenu": "_displayedContextualMenu_1l7di_86",
  "taskStatus": "_taskStatus_1l7di_90",
  "placeholder": "_placeholder_1l7di_96",
  "row": "_row_1l7di_101",
  "comments": "_comments_1l7di_106"
};